import { LungWeatherReview } from '../models/lung-weather';
import BaseService from './BaseService';

export class LungWeatherService extends BaseService {
  url = `/lung-weather`;

  /**
   * The review for one lung disease on the current user's farm. The farm is taken from the token rather than
   * passed, like the rest of the farm-facing API.
   */
  getReview = async (diseaseId: string, historyDays = 90): Promise<LungWeatherReview> => {
    const query = this.BuildQueryString({ historyDays });
    const result = await this.Fetch(`${this.url}/diseases/${diseaseId}?${query}`, 'GET');

    return this.FromResult<LungWeatherReview>(result);
  };
}

export default LungWeatherService;
